import { defineStore } from "pinia";

import { errorMessage, errorToString } from "@/error/errorUnwrapper";
import { Counter } from "@/model/Counter";
import { statHistory } from "@/model/Settings";
import type { Statistics } from "@/model/baseTypes";

export function startStatistics() {
  setInterval(() => useStatisticsStore().addNewEntry(), 5000);
}

export const statsProvider = {
  subscriptions: () => 0,
  storesLen: () => 0,
};

export const useStatisticsStore = defineStore("statistics", {
  state: () => ({ statistics: [newEntry()] }),
  getters: {
    current: (state) => state.statistics[state.statistics.length - 1],
  },
  actions: {
    addNewEntry() {
      this.statistics.push(newEntry(this.current));
      if (this.statistics.length > statHistory) {
        this.statistics.splice(0, 1);
      }
    },
    addOk(type: StatisticsCounter) {
      this.current[type].addOk();
    },
    addFail(type: StatisticsCounter, detail?: unknown) {
      const key = detail ? errorMessage(detail, errorToString(detail, "Unknown")) : undefined;
      this.current[type].addFail(key);
    },
  },
});

type StatisticsCounter = keyof Pick<Statistics, "receives" | "calls" | "publishes" | "sends">;

function newEntry(oldEntry?: Statistics): Statistics {
  return {
    receives: new Counter(oldEntry?.receives),
    calls: new Counter(oldEntry?.calls),
    publishes: new Counter(oldEntry?.publishes),
    sends: new Counter(oldEntry?.sends),
    subscriptions: statsProvider.subscriptions(),
    reconnects: oldEntry?.reconnects || 0,
    storesLen: statsProvider.storesLen(),
  };
}
